"use client";

import { Button, Dialog, DialogBody, DialogContent, DialogTitle, DialogTrigger } from "@ubud-ui/react-ui-kit";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";

export function AuthenticationDialog() {
  const pathname = usePathname();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button className="font-bold w-full flex text-base p-6">Lamar Sekarang</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogTitle></DialogTitle>
        <DialogBody>
          <div>
            <Image
              src="/profile-completion.webp"
              alt="Login screen"
              width="224"
              height="224"
              className="h-[224px] w-auto object-contain mx-auto"
            />
            <div className="text-center space-y-4 mt-6">
              <h6 className="text-xl font-bold">Masuk terlebih dahulu</h6>
              <div className="text-gray-600">
                Sebelum melanjutkan melamar pada lowongan, Anda harus masuk terlebih dahulu dengan akun SIAPkerja.
              </div>
            </div>
            <div className="mt-10 flex items-center justify-center text-center">
              <Button className="font-bold text-base p-6" asChild>
                <Link prefetch={false} href={"/api/naco/login?redirect_url=" + pathname}>
                  Masuk Sekarang
                </Link>
              </Button>
            </div>
          </div>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
